import { CustomField, fieldProps, lookupPipeline, renderLink } from './helpers'

const renderDistributionLink = renderLink('/cat/distributions')

const categoryPipeline = lookupPipeline('distribution_categories', 'category')
const subcategoryPipeline = lookupPipeline('distribution_subcategories', 'subcategory')
const positionPipeline = lookupPipeline('positions', 'position', '_id')
const positionContractPipeline = [
  ...positionPipeline,
  ...lookupPipeline('cat_contracts', 'position.contract')
]
const createdByPipeline = lookupPipeline('users', 'createdBy')
const updatedByPipeline = lookupPipeline('users', 'updatedBy')

const requiredFields = ['subcategory.name']

const fields: CustomField[] = [
  // Main
  { name: 'subcategory.name', label: 'Subcategory', pipeline: subcategoryPipeline, ...fieldProps.text, render: renderDistributionLink },
  { name: 'category.name', label: 'Category', pipeline: categoryPipeline, ...fieldProps.text },
  { name: 'date_posted', label: 'Date Posted', ...fieldProps.date },

  // Position
  { name: 'position.id', label: 'Position ID', pipeline: positionPipeline, ...fieldProps.text },
  { name: 'position.title', label: 'Position Title', pipeline: positionPipeline, ...fieldProps.text },
  { name: 'position.contract.name', label: 'Contract Name', pipeline: positionContractPipeline, ...fieldProps.text },
  { name: 'position.contract.abbreviation', label: 'Contract Abbreviation', pipeline: positionContractPipeline, ...fieldProps.text },

  // Notes
  { name: 'notes', label: 'Notes', ...fieldProps.text },

  // Audit
  { name: 'createdBy.name', label: 'Created By', pipeline: createdByPipeline, ...fieldProps.text },
  { name: 'updatedBy.name', label: 'Updated By', pipeline: updatedByPipeline, ...fieldProps.text },
  { name: 'createdAt', label: 'Created At', ...fieldProps.date },
  { name: 'updatedAt', label: 'Updated At', ...fieldProps.date }
]

export const config = {
  fields,
  requiredFields,
  requiredFieldObjects: fields.filter(f => requiredFields.includes(f.name))
}
